<template>
  <!-- set-company-info .ech -->
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>企业中心</BreadcrumbItem>
          <BreadcrumbItem>企业动态</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibition/index/add-news')">
          <span class="htb-add">+</span>
          <span>添加动态</span>
        </div>
      </div>
    </div>

    <div class="my-item news-audit">
      <template v-if="newsList && newsList.length">
        <Row :gutter="30">
          <Col style="width:20%;float:left" v-for="(item, index) in newsList" :key="index">
          <div class="my-item-box">
            <div class="mi-top">
              <span class="mi-top-audit" v-if="item.auditSatus===0">审核中</span>
              <span class="mi-top-audit" v-if="item.auditSatus===1">审核通过</span>
              <span class="mi-top-count" v-if="item.ClickCount">点击量: {{item.ClickCount}}</span>
              <Poptip trigger="hover" title="审核不通过原因" :transfer="true" :content="item.auditRemark" style="width:90px;">
                <span class="mi-top-audit" style="color:#b10042;top:-15px;" v-if="item.auditSatus===-1">审核不通过</span>
              </Poptip>
              <img :src="item.coverUrl" v-if="item.coverUrl" />
              <img src="@assets/img/empty.png" v-else />
            </div>
            <div class="mi-title f-tac" :title="item.title">{{item.title}}</div>
            <div class="mi-tool">
              <div class="mi-tool-item z-primary" @click="showEdit(item)">编辑</div>
              <div class="mi-tool-line">|</div>
              <div class="mi-tool-item">
                <Poptip confirm placement="top-start" title="确认删除此动态吗 ?" @on-ok="delItem(item)" @on-cancel="handleClose()">删除</Poptip>
              </div>
            </div>
          </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "company-share",
  data() {
    return {
      newsList: [],
      pageSize: 15,
      pageIndex: 1,
      totalCount: 0,
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
      joinInfo: "loginModule/getJoinInfo",
    }),
  },
  created() {
    this.init();
  },
  components: {},
  methods: {
    ...mapMutations({
      setExhibition: "loginModule/setExhibition",
      setCompany: "loginModule/setCompany",
    }),
    ...mapActions({
      getNewsByJoinId: "getNewsByJoinId",
      delNews: "delNews",
    }),
    handleClose() {},
    async delItem(e) {
      let bool = await this.delNews(e.id);
      if (bool && bool.successed) {
        this.$Message.success("操作成功！");
        this.init();
      } else {
        this.$Message.error("操作失败，请重试！");
      }
    },
    showEdit(e) {
      this.$router.push("/exhibition/index/edit-news?id=" + e.id);
    },
    async init() {
      let list = await this.getNewsByJoinId({
        compId: this.company.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      });
      if (list && list.items) {
        this.newsList = list.items;
      }
      this.pageSize = list.pageSize;
      this.pageIndex = list.pageIndex;
      this.totalCount = list.totalCount;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
  },
};
</script>

<style scoped lang="scss">
.mi-top-audit {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #ccc;
  color: #000;
  z-index: 100;
  padding: 2px 10px;
  font-size: 14px;
}
.mi-top-count {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ccc;
  color: #000;
  z-index: 100;
  padding: 2px 10px;
  font-size: 14px;
}
.my-page {
  text-align: center;
}
</style>
<style lang="scss">
.news-audit {
  .ivu-poptip-rel {
    width: 100%;
  }
}
</style>


